import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const AdminBanksServices = {
  getMutasiBank
}

function getMutasiBank (opt) {
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('mutasibank_sort')
    } else {
      localStorage.setItem('mutasibank_sort', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10
  }

  if (!opt.search) {
    opt.search = ''
  }
  if (typeof opt.statustrx === 'undefined' || opt.statustrx === null) {
    opt.statustrx = ''
  }
  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/admin/v1/bank/mutasi?bankcode=' + opt.bankcode + '&search=' + opt.search + '&statustrx=' + opt.statustrx + '&awal=' + opt.awal + '&akhir=' + opt.akhir + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
